export type Rgb = [number, number, number]

export const hexToRgb = (hex: string): Rgb => {
    const value = hex.replace('#', '').trim()
    const full = value.length === 3 ? value.split('').map((char) => char + char).join('') : value
    const number = parseInt(full, 16)

    if (Number.isNaN(number)) return [255, 255, 255]

    return [(number >> 16) & 255, (number >> 8) & 255, number & 255]
}

// Space separated channels for use as rgb(var(--name) / alpha) in CSS
export const toRgbChannels = (hex: string): string => hexToRgb(hex).join(' ')

export const mixRgb = (a: Rgb, b: Rgb, t: number): Rgb => [
    Math.round(a[0] + (b[0] - a[0]) * t),
    Math.round(a[1] + (b[1] - a[1]) * t),
    Math.round(a[2] + (b[2] - a[2]) * t)
]

export const rgba = (color: Rgb, alpha: number): string => {
    const a = alpha < 0 ? 0 : alpha > 1 ? 1 : alpha

    return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${a.toFixed(4)})`
}
